module.exports = __webpack_public_path__ + "static/media/add-icon.669fe38f.svg";